export default __webpack_public_path__ + "static/media/printerIcon.af496124.svg";